module.exports = __webpack_public_path__ + "static/SivaPrasadRdy-b04c5c948649051e70b8d98495018f74.jpg";